import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import {
    Grid,
    FormControl,
    InputLabel,
} from "@material-ui/core";
import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import {appConstants} from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: 200
    },
    root: {
        flexGrow: 1,
        paddingLeft: '15px',
        marginBottom: '10px'
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: '0 5px 0',
        minWidth: 120,
        width: '90%',
        display: "flex",
        wrap: "nowrap"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px"
    }
});

function SearchComponent(props) {
    // let { classes, airlines, selectChange, AirlineId, FlightNumber, StartDate, EndDate, flightNumbers } = props;
    let { airports, user, classes, startDate, endDate, airlines, selectChange,
        onSearch, handleDateChange, flightNumbers, AirlineId, airportCode, flightNumber } = props;
    return (
        <div className={classes.root}>
            <Grid container spacing={24}>
                <Grid item md={2}>
                    <FormControl
                        className={classes.formControl}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Airlines
                        </InputLabel>
                        <AutocompleteSelect
                            options={airlines.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                            selectedOption={AirlineId}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            // selectLabel={"Airlines"}
                            disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                            name={"AirlineId"}
                        />
                        {/*<Select*/}
                            {/*value={AirlineId}*/}
                            {/*disabled={user.AppRole === appConstants.ROLES.AIRLINE}*/}
                            {/*onChange={selectChange}*/}
                            {/*input={<Input name="airline" id="airline-label-placeholder" />}*/}
                            {/*// displayEmpty*/}
                            {/*name="AirlineId"*/}
                            {/*className={classes.selectEmpty}*/}
                        {/*>*/}
                            {/*<MenuItem value="-1">All Airlines</MenuItem>*/}
                            {/*{airlines.map((option, i) => (*/}
                                {/*<MenuItem*/}
                                    {/*key={i}*/}
                                    {/*value={option.AirlineId}*/}
                                    {/*className={classes.select}*/}
                                {/*>*/}
                                    {/*{option.Airline}*/}
                                {/*</MenuItem>*/}
                            {/*))}*/}
                        {/*</Select>*/}
                    </FormControl>
                </Grid>
                <Grid item md={2} sm={12}>
                    <FormControl className={classes.formControl}>
                        <InputLabel shrink htmlFor="age-simple">Airports</InputLabel>
                        <AutocompleteSelect
                            options={airports.map(option => ({ value: option.Code, label: option.Name }))}
                            selectedOption={airportCode}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            selectLabel={"Airports"}
                            disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}
                            name={"airportCode"}
                        />
                        {/*<Select*/}
                            {/*disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER || (user.Location)}*/}
                            {/*value={airportCode}*/}
                            {/*onChange={(event)=>handleSelect(event)}*/}
                            {/*formcontrolprops={{*/}
                                {/*fullWidth: true*/}
                            {/*}}*/}
                            {/*inputProps={{*/}
                                {/*name: 'airportCode',*/}
                                {/*id: 'airportCode',*/}
                            {/*}}*/}
                        {/*>*/}
                            {/*<MenuItem value="-1">All Airports</MenuItem>*/}
                            {/*{airports.map((option, i) => (*/}
                                {/*<MenuItem*/}
                                    {/*key={i}*/}
                                    {/*value={option.Code}*/}
                                    {/*className={classes.select}*/}
                                {/*>*/}
                                    {/*{option.Name}*/}
                                {/*</MenuItem>*/}
                            {/*))}*/}
                        {/*</Select>*/}
                    </FormControl>
                </Grid>
                <Grid item md={2}>
                    <FormControl
                        className={classes.formControl}
                    >
                        <InputLabel shrink htmlFor="age-label-placeholder">
                            Flight Number
                        </InputLabel>
                        <AutocompleteSelect
                            options={flightNumbers.map(option => ({value: option.FlightNumber, label: option.FlightNumber}))}
                            name={"flightNumber"}
                            handleSelectChange={(e, name) => selectChange(e, name)}
                            selectedOption={flightNumber}

                        />
                        {/*<Select*/}
                            {/*value={flightNumber}*/}
                            {/*disabled={AirlineId === "-1"}*/}
                            {/*onChange={handleSelectFlightNumber}*/}
                            {/*input={<Input name="flightNumber" id="airline-label-placeholder" />}*/}
                            {/*// displayEmpty*/}
                            {/*name="flightNumber"*/}
                            {/*className={classes.selectEmpty}*/}
                        {/*>*/}
                            {/*<MenuItem value="-1">All Flights</MenuItem>*/}
                            {/*{flightNumbers ? flightNumbers.map((option, i) => (*/}
                                {/*<MenuItem*/}
                                    {/*key={i}*/}
                                    {/*value={option.FlightNumber}*/}
                                    {/*className={classes.select}*/}
                                {/*>*/}
                                    {/*{option.FlightNumber}*/}
                                {/*</MenuItem>*/}
                            {/*))*/}
                            {/*:""}*/}
                        {/*</Select>*/}
                    </FormControl>
                </Grid>
                <Grid item md={3}>
                        <InlineDatePicker label={'Start Date'} Date={startDate}  handleDateChange={(date) => handleDateChange(date, 'startDate')} />
                </Grid>
                <Grid item md={3}>
                        <InlineDatePicker label={'End Date'} Date={endDate}  handleDateChange={(date) => handleDateChange(date, 'endDate')} />
                </Grid>
                <Grid item md={2}>
                    <br/>
                    <Button color={'regional'} onClick={()=>onSearch()}>Search</Button>
                </Grid>
            </Grid>
        </div>
    );
}

SearchComponent.propTypes = {
    classes: PropTypes.object.isRequired,
    selectChange: PropTypes.func.isRequired
};

export default withStyles(styles)(SearchComponent);



// WEBPACK FOOTER //
// ./src/Regional-Views/Transit/SearchPanel.jsx